import React, { useEffect, useState } from "react";
import Logo from "../assets/images/Logo_2.png";
import { Link } from "react-router-dom";
import "../style/navbar.css";
import { useDispatch } from "react-redux";
import { toggelTheme } from "../reduxToolKit/Slices/Theme";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun,faMoon,faChevronUp} from'@fortawesome/free-solid-svg-icons';
function Navbar() {
    const dispatch = useDispatch();
    const [click, setClicked] = useState(false);
    const [clickTh, setClickedTh] = useState(false);
    const[clicktog,setClickedtog]=useState(false)
    const [isDark, setMode] = useState(() => {
        const storedMode = localStorage.getItem("Mode");
        return storedMode ? JSON.parse(storedMode) : false;
    });

    useEffect(() => {
        localStorage.setItem("Mode", JSON.stringify(isDark));
        dispatch(toggelTheme(isDark));
    }, [isDark, dispatch]);

    return (
        <div className={`${isDark&&"dark"}`} >
            <div className="nav w-screen  dark:from-gray-900 dark:to-gray-600  bg-gradient-to-l from-blue-400 to-creamy fixed z-50 top-0 shadow-lg dark:shadow-gray-400 shadow-blue-600" onClick={() => {
            // if (click === true) {
            //     setClicked(false);
            // }
            // if (clickTh === true) {
            //     setClickedTh(false);
            // }
        }}>
                <div className="Logo flex">
                    <span className="bg-blue-300 p-1 rounded-full">
                        <Link to="/"><img className="w-14 h-14 rounded-full" src={Logo} alt="Not Found" /></Link>
                    </span>
                    <span className="text-darkblue dark:text-creamy font-bold animate-bounce items-center mt-3 ml-3 text-2xl">Portfolio</span>
                </div>
                <div className="Linkes min-[1060px]:block">
                    <Link className="lin" to="/">Home</Link>
                    <Link className="lin" to="/about">About</Link>
                    <Link className="lin" to="/worksPage">Work</Link>
                    <Link className="lin" to="/Contact">Contact</Link>
                </div>
                <button className="p-2 hidden min-[436px]:block  rounded-sm bg-opacity-45 bg-blue-800 mr-12 text-creamy text-xl font-semibold" onClick={() => {
                    setClickedTh(cl => !cl);
                }}>{isDark?<sapn> <FontAwesomeIcon icon={faMoon} className="mr-2" />Dark</sapn>:<sapn> <FontAwesomeIcon icon={faSun} className="mr-2" />Light</sapn>} <span className=""><FontAwesomeIcon icon={faChevronUp} className={`w-8 h-6 text-white   transform ${clickTh ?" rotate-180 transform duration-500" :"  duration-500"}   `}/></span></button>
                
                <div className="group w-8 mr-3 max-[1061px]:block items-center" onClick={() => {
                    setClicked(ev => !ev);
                }}>
                    <span className="items-center -translate-x-5 pt-3 flex gap-2 flex-wrap justify-end">
                        {click ? <>
                            <span className="spn bg-creamy w-full h-1 items-center transform rotate-45 duration-500 translate-y-2.5"></span>
                            <span className="spn bg-creamy w-full h-1 items-center transform -rotate-45 duration-500"></span>
                        </> : <>
                            <span className="spn h-0.5 w-full bg-creamy items-center"></span>
                            <span className="spn h-0.5 w-3/5 bg-creamy items-center flex group-hover:w-full transform-gpu duration-500"></span>
                            <span className="spn h-0.5 bg-creamy w-full items-center"></span>
                        </>}
                    </span>
                </div>
                {click &&
                    <div className="toggel w-64 z-50 dark:bg-slate-700 bg-blue-200 rounded-md absolute right-3 top-16">
                        <span><FontAwesomeIcon icon={faChevronUp} className={`w-8 h-6 text-white rotate-180  transform  duration-1000 `}/></span>
                        <ul className="mx-auto">
                            <li><Link className="tlist dark:hover:bg-gray-300 dark:text-creamy" to="/">Home</Link></li>
                            <li><Link className="tlist dark:hover:bg-gray-300 dark:text-creamy" to="/about">About</Link></li>
                            <li><Link className="tlist dark:hover:bg-gray-300 dark:text-creamy" to="/worksPage">Work</Link></li>
                            <li><Link className="tlist dark:hover:bg-gray-300 border-none dark:text-creamy" to="/Contact">Contact</Link></li>
                            <li className=" tli hidden dark:hover:bg-gray-300 max-[435px]:block dark:text-creamy" onClick={()=>{
                                setClickedtog(ev =>!ev)
                            }}> {isDark?<sapn> <FontAwesomeIcon icon={faMoon} className="mr-2" />Dark</sapn>:<sapn> <FontAwesomeIcon icon={faSun} className="mr-2" />Light</sapn>}
                            <span className="ml-14"><FontAwesomeIcon icon={faChevronUp} className={`w-8 h-6 text-white   transform ${clicktog ?" rotate-180 transform duration-500" :"  duration-500"}   `}/></span>
                            {clicktog&&
                                <ul  className=" mx-auto   ">
                                <li><Link className="tlist dark:hover:bg-gray-400 dark:text-creamy" onClick={() => {
                                    setMode(true);
                                }}>Dark</Link></li>
                                <li><Link className="tlist dark:text-creamy dark:hover:bg-gray-400" onClick={() => {
                                    setMode(false);
                                }}>Light</Link></li>
                                </ul>
                                
                            }
                        </li>
                        </ul>
                    </div>
                }
                {clickTh &&
                    <div className="toggel w-64 z-50 dark:bg-slate-700 bg-blue-200 rounded-md absolute right-5 top-16">
                        <ul className="mx-auto">
                            <li><Link className="tlist dark:text-creamy dark:hover:bg-gray-400" onClick={() => {
                                setMode(true);
                            }}>Dark</Link></li>
                            <li><Link className="tlist dark:text-creamy dark:hover:bg-gray-400" onClick={() => {
                                setMode(false);
                            }}>Light</Link></li>
                        </ul>
                    </div>
                }
            </div>
        </div>
    );
}

export default Navbar;
